import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Item = styled.li`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid var(--border-soft);
  background: var(--background-soft);
  cursor: pointer;

  &:hover,
  &[aria-selected='true'] {
    background: var(--surface-active);
  }

  p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    ${typographyV2.bodyBase}
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: var(--text-soft);

  & svg {
    fill: var(--icon-soft);
  }
`;

export const SourceDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 0px;
`;

export const EntityDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-default);
`;

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
`;
